import { useEffect, useRef, useState } from 'react';

// Request chỉ được thay đổi phiên form đã gửi nó, kể cả khi người dùng mở bản ghi khác.
export default function usePolicyFormSave(onSubmit, onCancel) {
    const active = useRef(true);
    const pending = useRef(false);
    const [saving, setSaving] = useState(false);

    useEffect(() => () => { active.current = false; }, []);

    const save = async values => {
        if (!active.current || pending.current) return;
        pending.current = true;
        setSaving(true);
        try {
            await onSubmit(values);
            if (active.current) onCancel();
        } catch (error) {
            // Redux đã thông báo lỗi; giữ nguyên dữ liệu để người dùng sửa và gửi lại.
        } finally {
            pending.current = false;
            if (active.current) setSaving(false);
        }
    };

    return { saving, save };
}
